import { orderWorkPackages } from "./planning-core.js";

function rootFor(item, byId) {
  let current = item;
  const seen = new Set();

  while (current?.parentId != null && byId.has(current.parentId)) {
    if (seen.has(current.id)) break;
    seen.add(current.id);
    current = byId.get(current.parentId);
  }

  return current ?? item;
}

export function withAncestorContext(workPackages, selectedWorkPackages) {
  const items = Array.isArray(workPackages) ? workPackages : [];
  const selected = Array.isArray(selectedWorkPackages) ? selectedWorkPackages : [];
  if (items.length === 0 || selected.length === 0) return [];

  const byId = new Map(items.map((item) => [item.id, item]));
  const includedIds = new Set();

  for (const selectedItem of selected) {
    let current = byId.get(selectedItem.id) ?? selectedItem;
    const seen = new Set();

    while (current && !seen.has(current.id)) {
      seen.add(current.id);
      includedIds.add(current.id);
      current = current.parentId == null ? null : byId.get(current.parentId);
    }
  }

  return orderWorkPackages(items)
    .filter(({ item }) => includedIds.has(item.id))
    .map(({ item }) => item);
}

export function buildHierarchyGroups(workPackages) {
  const items = Array.isArray(workPackages) ? workPackages : [];
  if (items.length === 0) return [];

  const byId = new Map(items.map((item) => [item.id, item]));
  const ordered = orderWorkPackages(items);
  const groups = new Map();

  for (const row of ordered) {
    const root = rootFor(row.item, byId);
    let group = groups.get(root.id);
    if (!group) {
      group = { root, children: [] };
      groups.set(root.id, group);
    }

    if (row.item.id !== root.id) {
      group.children.push({
        item: row.item,
        depth: Math.max(1, row.depth),
      });
    }
  }

  return [...groups.values()];
}

export function buildWeekHierarchyGroups(workPackages) {
  return buildHierarchyGroups(workPackages);
}
